"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ArrowLeftLine["default"];
  }
});

var _ArrowLeftLine = _interopRequireDefault(require("./lib/icons/ArrowLeftLine"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
